module.exports = __webpack_public_path__ + "static/media/image8.fe23936a.JPG";